import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

export type DeleteAppointmentV2ManagerArgs = {
  managerId: number;
  appointmentId: number;
};

export const useDeleteAppointmentV2Manager = () => {
  const client = useApiClient();

  return useMutation<null, Error, DeleteAppointmentV2ManagerArgs>({
    mutationFn: args => client.deleteAppointmentV2Manager(args),
  });
};
